import type {EditExpedientNoteFormPayload} from "./edit-expedient-note.schema";
import {EditExpedientNoteBody} from "@project/sdk/sales/zod";
import {editExpedientNote} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";
import {expedientKeys, expedientMutationKeys} from "../../../../../expedient-keys";

export function editExpedientNoteMutationOptions(id: string, noteId: number) {
  return mutationOptions({
    mutationKey: expedientMutationKeys.editExpedientNote,
    mutationFn: (payload: EditExpedientNoteFormPayload) =>
      editExpedientNote(id, noteId, EditExpedientNoteBody.parse(payload)),
    onSuccess: async (_result, _payload, _context, {client}) => {
      await client.invalidateQueries({queryKey: expedientKeys.detail(id)});
    },
  });
}
